$(document).ready(function() {
  var Accordion = function (el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    var links = this.el.find(".link");
    links.on("click", { el: this.el, multiple: this.multiple }, this.dropdown);
  };

  Accordion.prototype.dropdown = function (e) {
    var $el = e.data.el;
    var $this = $(this),
      $next = $this.next();
    var $openIcon = $this.find("#open-icon");
    var $closeIcon = $this.find("#close-icon");

    $next.slideToggle();
    $this.parent().toggleClass("open");

    if ($this.parent().hasClass("open")) {
      $openIcon.hide();
      $closeIcon.show();
    } else {
      $openIcon.show();
      $closeIcon.hide();
    }

    if (!e.data.multiple) {
      $el
        .find(".submenu-mob")
        .not($next)
        .slideUp()
        .parent()
        .removeClass("open")
        .find("#open-icon")
        .show()
        .end()
        .find("#close-icon")
        .hide();
    }
  };

  var accordion = new Accordion($("#accordion"), false);
});
